import { render, staticRenderFns } from "./VendPop.vue?vue&type=template&id=8b85b1aa&"
import script from "./VendPop.vue?vue&type=script&lang=js&"
export * from "./VendPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports